/** Multicity From/To empty-field copy (desktop overlay + airport sheet). */
export const MULTICITY_FROM_PLACEHOLDER = 'Bangalore, India (BLR)';
export const MULTICITY_TO_PLACEHOLDER = 'New Delhi, India (DEL)';
/** Multicity mobile row — compact 3-letter hints (narrow side-by-side columns). */
export const MULTICITY_MOBILE_FROM_HINT = 'BLR';
export const MULTICITY_MOBILE_TO_HINT = 'DEL';
/** One-way / round-trip From/To empty-field copy (all breakpoints). */
export const ORIGIN_PLACEHOLDER = 'Select Origin';
export const DEST_PLACEHOLDER = 'Select Destination';
/** Shown in the From/To list when a search returns no airports. */
export const AIRPORT_SEARCH_EMPTY_MESSAGE = 'No airports found';

/** Left inset for nearby-airport rows under the main destination. */
export const NEARBY_AIRPORT_PADDING_LEFT = '36px';

export const TRAVEL_CLASS_LABELS = {
  ECONOMY: 'Economy',
  BUSINESS: 'Business Class',
  FIRST: 'First Class',
  PREMIUM_ECONOMY: 'Premium Economy',
};

/** Traveller popover — shared by the one-way strip and the multi-city strip. */
export const PASSENGER_MAX = 9;
export const PASSENGER_DEFAULT_COUNTS = { adults: 1, children: 0, infants: 0 };
export const PASSENGER_DROPDOWN_ROW_GAP = { xs: '10px', md: '12px' };
export const PASSENGER_DROPDOWN_LABEL_GAP = { xs: '4px', md: '6px' };
export const PASSENGER_DROPDOWN_PAPER_SX = {
  position: { xs: 'fixed', md: 'absolute' },
  top: { xs: '50%', md: '100%' },
  left: { xs: '50%', md: '50%' },
  transform: { xs: 'translate(-50%, -50%)', md: 'translateX(-50%)' },
  zIndex: 1401,
  isolation: 'isolate',
  background: '#FFFFFF',
  border: '1px solid rgba(32, 32, 42, 0.06)',
  borderRadius: '16px',
  boxShadow: '0 16px 40px rgba(32, 32, 42, 0.16)',
  p: { xs: '12px', md: '14px 14px 12px' },
  mt: { xs: 0, md: '8px' },
  minWidth: { xs: '300px', md: '360px' },
  width: { xs: 'calc(100vw - 48px)', md: '380px' },
  maxWidth: { xs: '380px', md: '380px' },
};

/** Journey type menu — same OptionDropdown as Class on the search strip. */
export const JOURNEY_OPTIONS = [
  { value: 'oneway', label: 'One Way' },
  { value: 'roundtrip', label: 'Round Trip' },
  { value: 'multicity', label: 'Multi City' },
];

/** Order for mobile Travellers & Class sheet chips (matches the class option menu). */
export const MOBILE_CLASS_OPTIONS = [
  { value: 'ECONOMY', label: 'Economy' },
  { value: 'BUSINESS', label: 'Business Class' },
  { value: 'FIRST', label: 'First Class' },
  { value: 'PREMIUM_ECONOMY', label: 'Premium Economy' },
];

export const SPECIAL_FARE_DISABLED_TOOLTIP = 'Remove children & infants to select this fare';

/** Info glyph stays 15px. The button grows to the 24px minimum tap target. */
export const SPECIAL_FARE_INFO_ICON_PX = 15;
export const SPECIAL_FARE_INFO_TARGET_PX = 24;

/** Special fare pills — subtitle shown inline; tooltip is desktop hover only (no airline names). */
export const SPECIAL_FARE_META = {
  regular: { title: 'Regular', subtitle: 'Regular Fares' },
  student: {
    title: 'Student',
    subtitle: 'Extra discounts/baggage',
    tooltip:
      'Applicable only for students above 12 years of age. Valid student ID cards and student visas (where applicable) are required to avail this.',
  },
  armedForces: {
    title: 'Armed Forces',
    subtitle: 'Defence personnel',
    tooltip:
      'Applicable for active and retired defence personnel and dependents. Valid Defence ID is required at check-in to avail this. Children and infants are allowed.',
  },
  seniorCitizen: {
    title: 'Senior Citizen',
    subtitle: 'Up to \u20B9 600 off',
    tooltip:
      'Applicable only for passengers 60 years of age or above. Valid age proof is required at check-in to avail this.',
  },
};

export const SPECIAL_FARE_KEYS = ['regular', 'student', 'armedForces', 'seniorCitizen'];

/** White popover-style tooltip — appears below pill with upward arrow (Figma reference). */
export const SPECIAL_FARE_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    className: 'special-fare-info-tooltip',
  },
  popper: {
    modifiers: [
      {
        name: 'offset',
        options: { offset: [0, 10] },
      },
    ],
  },
};

export const emptyCalendarPrices = {};

/**
 * Height reserved for the multi-city rows while their chunk downloads:
 * total = base + perRow × rows (measured from the rendered rows, incl. the Add City/Trip button).
 */
export const MULTICITY_ROWS_PLACEHOLDER_HEIGHT = {
  mobile: { base: 32, perRow: 104 },
  desktop: { base: 48, perRow: 103 },
};
